<template>
  <!-- 長崎空港経由 -->
  <div id="route-2" class="route-container">
    <div class="course-block">
      <div v-for="no in 2" class="block-wrapper">
        <div class="block">
          <div class="title">{{ $t(`page.access.route-detail.route-2.course-${no}.title`) }}</div>
          <div class="description" v-html="$t(`page.access.route-detail.route-2.course-${no}.description`)"></div>
          <div class="time">
            <img
              :src="getIconPath($t(`page.access.route-detail.route-2.course-${no}.icon`))"
              :alt="$t(`page.access.route-detail.route-2.course-${no}.icon`)"
            />
            <div class="text" v-html="$t(`page.access.route-detail.route-2.course-${no}.time`)"></div>
          </div>
        </div>
        <div class="arrow"></div>
      </div>
    </div>
    <div class="goal block">{{ $t(`page.access.route-detail.goal`) }}</div>
    <div class="annotation">
      <div class="text">{{ $t('page.access.annotation.time-disclaimer-text') }}</div>
      <div class="text">{{ $t('page.access.annotation.shuttle-disclaimer-text') }}</div>
    </div>
  </div>
</template>
<script setup lang="ts">
// 指定フォルダのSVGファイルをビルド時に一括で解決しておく
import Route1 from "~/components/uiParts/Routes/Route1.vue";

const images: Record<string, string> = import.meta.glob('~/assets/pages/access/*.svg', { eager: true, import: 'default' });

// 動的なファイル名から実際のURLを取得する関数
const getIconPath = (iconName: string): string => {
  // globで取得したオブジェクトのキーから、該当ファイル名を含むパスを探す
  const globKey = Object.keys(images).find(key => key.endsWith(`/${iconName}.svg`)) ?? '';
  return images[globKey] ?? '';
};
</script>
<style lang="scss" scoped>
@use '@/assets/styles/mixins' as m;
@use '@/assets/styles/variables' as v;

.route-container {
  padding: 32px 22px;

  @include m.sp() {
    padding: 0;
  }
}

/* 各ブロックの要素 */
.block {
  width: 100%;
  padding: 10px;
  border: 1px solid v.$common-element-color;
  /* font-size: 1.5rem; */
  font-size: clamp(1.4rem, -8.75rem + 18vw, 1.5rem);
  word-break: keep-all;
  line-height: 1.2;

  @include m.sp() {
    font-size: 1rem;
    letter-spacing: 2.4px;
    padding: 6px 4px;
  }
}

/* 矢印 */
.arrow {
  position: relative;
  width: 3px;
  height: 32px;
  background-color: v.$common-element-color;
  margin-bottom: 9px;

  @include m.sp() {
    width: 2px;
    height: 12px;
    margin-bottom: 6px;
  }

  /* 矢印の▼部 */
  &::after {
    content: '';
    position: absolute;
    bottom: -9px;
    left: -7px;
    border-left: 9px solid transparent;
    border-right: 9px solid transparent;
    border-top: 9px solid v.$common-element-color;

    @include m.sp() {
      bottom: -6px;
      left: -5px;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-top: 6px solid v.$common-element-color;
    }
  }
}

/* 所要時間付きブロック */
.course-block {
  > .block-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;

    > .block {
      padding: 0;
      width: 100%;

      > .title {
        padding: 0 8px 8px;
        margin-top: 20px;

        @include m.sp() {
          padding: 4px 0 0;
          margin-top: 8px;
        }
      }
      > .description {
        /* font-size: 1.125rem; */
        font-size: clamp(1rem, -9.125rem + 18vw, 1.125rem);
        word-break: keep-all;
        padding: 4px 8px;
        line-height: 1.3;

        @include m.sp() {
          font-size: 0.75rem;
          letter-spacing: 1.8px;
          padding: 4px 8px;
        }
      }
      /* 所要時間 */
      > .time {
        display: flex;
        justify-content: center;
        gap: 16px;
        background: v.$common-element-color;
        padding: 8px 10px;
        margin-top: 8px;

        @include m.sp() {
          gap: 8px;
          padding: 0;
          margin-top: 4px;
        }

        > img {
          width: 30px;

          @include m.sp() {
            width: 20px;
          }
        }

        > .text {
          color: v.$common-white-color;
          /* font-size: 1.125rem; */
          font-size: clamp(1rem, -9.125rem + 18vw, 1.125rem);
          word-break: keep-all;
          line-height: 1.3;
          text-align: left;

          @include m.sp() {
            font-size: 0.75rem;
            letter-spacing: 1.8px;
            padding: 8px 0;
          }
        }
      }
    }
  }
}

/* 目的地 */
.goal {
  background: v.$accent-color;
  border: none;
  color: v.$common-white-color;
}

/* 注釈 */
.annotation {
  font-size: 0.75rem;
  margin-top: 40px;
  margin-left: -24px;
  letter-spacing: 1.8px;
  text-align: left;
  line-height: 2.3;
  .text{
    margin:8px 0;
  }
  @include m.sp() {
    font-size: 0.8125rem;;
    margin-top: 16px;
    margin-left: 0;
    letter-spacing: 1.95px;
  }
}
</style>
